import { nsmApiService } from './nsm-api-service';
import { ccApiService } from './cc-api-service';
import { wcmApiService } from './wcm-api-service';

class UnifiedInsightsApiService {
  private firewall =  nsmApiService;
  private captureClient =  ccApiService;
  private wireless =  wcmApiService;

  getDataGroupApiWrapper(dataGroup: string) {
    if (dataGroup === 'firewall') {
      return this.firewall;
    }
    if (dataGroup === 'capture client') {
      return this.captureClient;
    }
    if (dataGroup === 'wireless') {
      return this.wireless;
    }
    return null;
  }
}

export const unifiedInsightsApiService = new UnifiedInsightsApiService();
